export default function Footer() {
  return (
    <footer className="footer small">
      <div className="d-flex justify-content-between flex-wrap gap-2">
        <span>© 2025 PulseFrame (fictional). Built for demo purposes.</span>
        <span>SPA · Mono Minimal · Cloudflare Workers</span>
      </div>
    </footer>
  );
}
